import React from 'react';

import { Box, Container, Typography, Grid } from '@mui/material';

interface ValuePropProps {
	image: string;
	header: string;
	content: string;
}

const ValueProp = ({ image, header, content }: ValuePropProps) => {
	return (
		<Box
			sx={{
				maxWidth: '358px',
			}}
		>
			<Box
				component='img'
				src={image}
				sx={{
					height: '218px',
					width: '100%',
					objectFit: 'cover',
					mb: 4,
					borderRadius: (theme) =>
						`${theme.cardShape?.borderRadius || theme.shape.borderRadius}px`,
				}}
			/>
			<Typography
				variant='h4'
				component='h3'
				color='primary.contrastText'
				mb={2}
			>
				{header}
			</Typography>
			<Typography variant='body1' color='primary.contrastText'>
				{content}
			</Typography>
		</Box>
	);
};

const AcepValueProps = () => {
	return (
		<Box
			sx={{
				backgroundColor: 'primary.main',
				py: {
					xs: 10,
					md: 25,
				},
			}}
		>
			<Container maxWidth='xl'>
				<Typography
					variant='h2'
					mb={10}
					color='primary.contrastText'
					textAlign={{
						xs: 'center',
						md: 'left',
					}}
				>
					You deserve to make career decisions based on what matters most to
					you.
				</Typography>
				<Grid
					container
					columnSpacing={4}
					rowSpacing={6}
					justifyContent='space-between'
				>
					<Grid item xs={12} md={4} container justifyContent='center'>
						<ValueProp
							image='https://assets.ivyclinicians.io/images/acep-value-prop-unique.png'
							header='Nothing like it'
							content='Unparalleled access to meaningful employer data found only here.'
						/>
					</Grid>
					<Grid item xs={12} md={4} container justifyContent='center'>
						<ValueProp
							image='https://assets.ivyclinicians.io/images/acep-value-prop-trust.png'
							header='Information you can trust'
							content='Vetted details to help you take control of your unique career journey.'
						/>
					</Grid>
					<Grid item xs={12} md={4} container justifyContent='center'>
						<ValueProp
							image='https://assets.ivyclinicians.io/images/acep-value-prop-transparency.png'
							header='Powered by transparency'
							content='Unprecedented insights on group structure, leadership, policies, and more.'
						/>
					</Grid>
				</Grid>
			</Container>
		</Box>
	);
};

export default AcepValueProps;
